import * as React from 'react';
export const regionsSvg = React.forwardRef(function regionsSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#8CC73E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M4.32 24.22 9.96 16 14 24.22H4.32zm23.36 0H18L22.04 16l5.64 8.22zm-10.87 0 2-12.74 2.83 4.1-4.83 8.64zm-1.62 0-4.83-8.63 2.82-4.1 2.01 12.73zm.81 0-2.42-13.15L16 7.78l2.42 3.29L16 24.22z',
      }),
    ),
  );
});
regionsSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var regions = {
  category: 'brand',
  colorable: false,
  name: 'regions',
  svg: regionsSvg,
};
